"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Card = exports["default"] = /*#__PURE__*/function (_Core) {
  function Card(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Card);
    _this = _callSuper(this, Card, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.init();
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.ready = false;
    _this.myServices = ["crs"];
    return _this;
  }
  (0, _inherits2["default"])(Card, _Core);
  return (0, _createClass2["default"])(Card, [{
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this3 = this;
        var payload;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                action: "System.CardReader.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: +new Date(),
                request_uuid: "",
                data: "{}"
              };
              _context.next = 4;
              return this.connection.invoke("messaging", payload);
            case 4:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                _this3.connection.on("messaging", function (msg) {
                  if (msg.action === "System.CardReader.Notify.Ready") {
                    if (!_this3.ready) {
                      _this3.ready = true;
                      _this3.trigger("ready", true);
                      _logger["default"].success("Initialization done", "Module is now ready", "Card");
                      resolve();
                    }
                  }
                });
              }));
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error("Error in getCheckReady:", _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "writeCard",
    value: function writeCard(cardData) {
      var payload = {
        action: "System.CardReader.CardWrite",
        uuid: (0, _uuid.v4)(),
        origin: "sdk-" + this.appName,
        timestamp: +new Date(),
        request_uuid: "",
        data: cardData
      };
      this.connection.invoke("messaging", payload)["catch"](function (error) {
        console.error("Error writing card:", error);
      });
    }
  }, {
    key: "cardReaderStart",
    value: function () {
      var _cardReaderStart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this4 = this;
        var uuid, origin, payload;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              _context3.next = 5;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.CardReaderStart",
                timestamp: +new Date(),
                params: "{}"
              }, uuid, origin);
            case 5:
              payload = _context3.sent;
              _context3.next = 8;
              return this.connection.invoke("messaging", payload);
            case 8:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                _this4.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(msg) {
                    var decryptedData, jsonObject;
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall')) {
                            _context2.next = 12;
                            break;
                          }
                          _context2.prev = 1;
                          _context2.next = 4;
                          return _encryption["default"].decryptSymmetrically(_this4.services["dpm"], msg.data);
                        case 4:
                          decryptedData = _context2.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (jsonObject.command === 'System.PeripheralsManager.CardReaderStart.Response') {
                            resolve(jsonObject.params);
                          }
                          _context2.next = 12;
                          break;
                        case 9:
                          _context2.prev = 9;
                          _context2.t0 = _context2["catch"](1);
                          reject(_context2.t0); // Properly handle decryption and parsing errors
                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2, null, [[1, 9]]);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              console.error("Error sending start card reader message:", _context3.t0);
              throw _context3.t0;
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 11]]);
      }));
      function cardReaderStart() {
        return _cardReaderStart.apply(this, arguments);
      }
      return cardReaderStart;
    }()
  }, {
    key: "cardReaderStop",
    value: function () {
      var _cardReaderStop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var _this5 = this;
        var uuid, origin, payload;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              _context5.next = 5;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.CardReaderStop",
                timestamp: +new Date(),
                params: "{}"
              }, uuid, origin);
            case 5:
              payload = _context5.sent;
              _context5.next = 8;
              return this.connection.invoke("messaging", payload);
            case 8:
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                _this5.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(msg) {
                    var decryptedData, jsonObject;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall')) {
                            _context4.next = 12;
                            break;
                          }
                          _context4.prev = 1;
                          _context4.next = 4;
                          return _encryption["default"].decryptSymmetrically(_this5.services["dpm"], msg.data);
                        case 4:
                          decryptedData = _context4.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (jsonObject.command === 'System.PeripheralsManager.CardReaderStop.Response') {
                            resolve(jsonObject.params);
                          }
                          _context4.next = 12;
                          break;
                        case 9:
                          _context4.prev = 9;
                          _context4.t0 = _context4["catch"](1);
                          reject(_context4.t0); // Properly handle decryption and parsing errors
                        case 12:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[1, 9]]);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](0);
              console.error("Error sending stop card reader message:", _context5.t0);
              throw _context5.t0;
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 11]]);
      }));
      function cardReaderStop() {
        return _cardReaderStop.apply(this, arguments);
      }
      return cardReaderStop;
    }()
  }, {
    key: "mockCardRead",
    value: function mockCardRead() {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.CardReader.FakeReadEvent",
          uuid: (0, _uuid.v4)(),
          origin: "sdk-" + _this6.appName,
          request_uuid: "",
          data: "{}"
        };
        _this6.connection.invoke("messaging", payload).then(function () {
          _this6.connection.on("messaging", function (msg) {
            if (msg.action === "System.CardReader.CardRead") {
              resolve();
            }
          });
        });
      });
    }
  }, {
    key: "handleMessages",
    value: function () {
      var _handleMessages = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(message) {
        var notification, data, data_read, data_write, requestData;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _context6.t0 = message.action;
              _context6.next = _context6.t0 === 'System.CardReader.CardRead' ? 5 : _context6.t0 === 'System.CardReader.CardRemoved' ? 8 : _context6.t0 === 'System.CardReader.CardWrite.Response' ? 11 : _context6.t0 === 'System.SDK.ServiceNotification.Response' ? 14 : _context6.t0 === 'System.ServiceNotification' ? 18 : 26;
              break;
            case 5:
              data_read = JSON.parse(message.data);
              this.trigger("cardRead", data_read);
              return _context6.abrupt("return");
            case 8:
              notification = JSON.parse(message.data);
              this.trigger("cardOut", notification);
              return _context6.abrupt("return");
            case 11:
              data_write = JSON.parse(message.data);
              this.trigger("cardWrite", data_write);
              return _context6.abrupt("return");
            case 14:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context6.next = 16;
                break;
              }
              return _context6.abrupt("return");
            case 16:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              return _context6.abrupt("return");
            case 18:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context6.next = 20;
                break;
              }
              return _context6.abrupt("return");
            case 20:
              // Send our data
              requestData = JSON.stringify(message.data); //changed this so server can recognize it
              _context6.next = 23;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(requestData.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 23:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context6.abrupt("return");
            case 26:
              return _context6.abrupt("break", 27);
            case 27:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleMessages(_x3) {
        return _handleMessages.apply(this, arguments);
      }
      return handleMessages;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Card");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Card");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.getCheckReady();
      _logger["default"].info("Check ready", "Checking if everything is ready", "Card");
      this.connection.on("messaging", this.handleMessages.bind(this)); //i get error here like on is not defined when called from encryption.js
    }
  }]);
}(_core["default"]);